import { withSvgIcon } from './withSvgIcon';

export const UsersIcon = withSvgIcon(
  <path
    d="M16.3542 11.0238C17.3993 11.8329 18.3333 13.8701 18.3333 15.1253C18.3333 15.5164 18.058 15.8334 17.7183 15.8334H17.3437M13.3854 7.70732C14.0615 7.30208 14.5164 6.54464 14.5164 5.67712C14.5164 4.80961 14.0615 4.05217 13.3854 3.64693M3.115 15.8334H13.9485C14.2881 15.8334 14.5635 15.5164 14.5635 15.1253C14.5635 12.6673 12.5816 10.6746 8.53175 10.6746C4.48186 10.6746 2.5 12.6673 2.5 15.1253C2.5 15.5164 2.77535 15.8334 3.115 15.8334ZM10.7937 5.67712C10.7937 6.97154 9.78096 8.02087 8.53175 8.02087C7.28253 8.02087 6.26984 6.97154 6.26984 5.67712C6.26984 4.38271 7.28253 3.33337 8.53175 3.33337C9.78096 3.33337 10.7937 4.38271 10.7937 5.67712Z"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
  />,
  { viewBox: '0 0 20 20' },
);
